import { useTranslation } from 'next-i18next';
import { VFC } from 'react';
import styles from './LatestNFTs.module.scss'
type Props = {
  isCreator: boolean,
};

const NoNFTS: VFC<Props> = ({
}) => {
  const { t } = useTranslation();
  return (
      <div className={styles.noNFTs}>
          {t("MarketplaceProfiles.NoNFTs")}
      </div>
  )
};

export default NoNFTS;